import { Component } from '@angular/core';
import { NavController,Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { provider } from '../../providers/provider';
import { CustomizerProvider } from '../../providers/customizer/customizer';

@Component({
  selector: 'page-about',
  templateUrl: 'about.html'
})
export class AboutPage {
  data: any;
  url: any;
  width;

  constructor(
    public navCtrl: NavController,
    public translateService: TranslateService, 
    public storage: Storage,
    public provider: provider,
    public platform: Platform,
    public customizer: CustomizerProvider) {

    this.url = provider.getUrl() + '/';
    this.data = provider.getMenu();

    platform.ready().then((readySource) => {
      this.width = platform.width();
    });

  }

  getUrl(img) {
    return this.url + img + '?w=' + this.width
  }

}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts